import { createTheme } from '@mui/material/styles';

import { borderRadius, spacing } from '../tokens';
import { paletteFigmaThemeConfig } from './themes/paletteFigmaThemeConfig';
import { typographyFigmaThemeConfig } from './themes/typographyFigmaThemeConfig';

/**
 * VDS base theme — palette + typography + shape + spacing from core tokens.
 *
 * This is the Tier 2 → MUI bridge. It contains no component-level overrides;
 * those are app opinions and belong in the consuming app's AppThemeProvider:
 *
 *   const appTheme = createTheme(vdsTheme, {
 *     components: { MuiButton: { ... } },
 *   });
 *
 * @since VDS Foundations 1.0
 */
export const vdsTheme = createTheme({
  palette: paletteFigmaThemeConfig,
  typography: typographyFigmaThemeConfig,
  shape: {
    borderRadius: borderRadius.md,
  },
  spacing: spacing[1],
});
